import React, { useState } from 'react';
import { CoffeeProvider } from './context/CoffeeContext';
import { Layout } from './components/Layout';
import { CoffeeForm } from './components/CoffeeForm';
import { CoffeeList } from './components/CoffeeList';
import { BrewingControlChart } from './components/BrewingControlChart';
import { BeansList } from './components/BeansList';
import { Account } from './components/Account';
export function App() {
  const [activeTab, setActiveTab] = useState('beans');
  return <CoffeeProvider data-id="element-0">
      <Layout activeTab={activeTab} setActiveTab={setActiveTab} data-id="element-1">
        {activeTab === 'add' && <CoffeeForm data-id="element-2" />}
        {activeTab === 'list' && <CoffeeList data-id="element-3" />}
        {activeTab === 'chart' && <BrewingControlChart data-id="element-4" />}
        {activeTab === 'beans' && <BeansList setActiveTab={setActiveTab} data-id="element-5" />}
        {activeTab === 'account' && <Account data-id="element-6" />}
      </Layout>
    </CoffeeProvider>;
}